module.exports = __webpack_public_path__ + "media/svg-new/key-login-e54175cb.svg";